/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import ContentType from 'material/embeds/contenttype/contenttype';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentindicator/contentindicator_styles';



/* ========== ~~~~~~~~~~ CONTENT INDICATOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ContentIndicator extends Component {
	handleType = (type) => {
		switch (this.props.type) {
			case 'select':
				this.props.processClick(type);
				break;
			case 'sort':
				this.props.processClick(type);
				break;
			case 'key':
			default:
				// console.log(type)
				break;
		}
	}
	isActive = (type) => {
		if(this.props.type === 'sort') { return false };
		return this.props.activeContents !== null && this.props.activeContents.length > 0 ? this.props.activeContents.includes(type) ||  this.props.activeContents.includes(type.toUpperCase()) : false;
	}
	render() {
        return (
            <span className={`contentindicator ${this.props.classes.contentindicator} type-${this.props.type} greyOut-${this.props.disabled}`}>
				<ContentType type={`quiz`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('quiz')} />
				<ContentType type={`poll`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('poll')} />
				<ContentType type={`story`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('story')} />
        	</span>
        )
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentIndicator);